import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCourt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCourt"><Path d="M12 1.95898L21 4.95898V9.99955H18.75L18.75 18.5H17.25L17.25 9.99955H14.75L14.75 18.5H13.25L13.25 9.99955H10.75L10.75 18.5H9.25L9.25 9.99955H6.75L6.75 18.5H5.25L5.25 9.99955H3V4.95898L12 1.95898Z" fill="currentColor"/><Path d="M21 21V19.5H3V21H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCourt;
